import { render, staticRenderFns } from "./StartMenu.vue?vue&type=template&id=12a13185&scoped=true&"
import script from "./StartMenu.vue?vue&type=script&lang=ts&"
export * from "./StartMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StartMenu.vue?vue&type=style&index=0&id=12a13185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a13185",
  null
  
)

export default component.exports